import "./i18nFallback";
import "webcrypto-shim/webcrypto-shim";
import { updatePayOptionTabs, clearTabContents, checkAndToggleUseOnDay } from './util/donateHelperFunctions';
import React from 'react';
import ReactDOM from 'react-dom/client';
import StationAutoComplete from './modules/donate/StationAutoComplete.jsx';

const recurrenceInputs = document.querySelectorAll('input[name="recurrence"]');
const radioMonthly = document.querySelector('input[value="Monthly"]');
const radioOneTime = document.querySelector('input[value="One Time"]');

function disableMonthlyRadio(target) {
  if (radioMonthly === null || radioOneTime === null) {
	return;
  }
  const closestA = target.closest('a');
  if (!closestA) {
	console.error("Could not find <a> for", target);
	return;
  }
  const clickedTab = target.closest('a').closest('li');
  // if not active tab, do nothing
  if (!clickedTab.classList.contains("active")) {
	return;
  }
  if (clickedTab.classList.contains('no-monthly')) {
	radioOneTime.checked = true;
	radioMonthly.disabled = true;
	radioMonthly.parentElement.classList.add('disabled');
  } else {
	radioMonthly.disabled = false;
	radioMonthly.parentElement.classList.remove('disabled');
  }
}

const autocompleteDiv = document.getElementById('autocomplete');
if (autocompleteDiv !== null) {
  const testDiv = ReactDOM.createRoot(autocompleteDiv);
  testDiv.render(
    <>
      <StationAutoComplete />
    </>
  );  
}

function submitAllowedBy3rdParties() {
  const tests = [
	!window.reCaptchaV3Wait || window.reCaptchaField.value,
	!window.usingStripe || window.stripeAllowsSubmit?.(),
  ];
  return tests.every(test => test);
}

function maybeSubmitForm(formElement) {
  if (submitAllowedBy3rdParties()) {
	formElement.submit();
  } else {
	document.querySelector(".btn-group").classList.remove("wait");
	const validationError = document.querySelector(".errorlist");
	if (validationError) {
	  validationError.parentElement.scrollIntoView();
	} else {
	  throw new Error("Donate form submission error.");
	}
  }
}

function hasRequiredDonationProductSelection() {
  const donationProductChoices = document.getElementById("goaas");
  if (donationProductChoices === null) {
    return true;
  }
  const wantedItem = donationProductChoices.querySelector(
    "input[name='wanted_item']:checked"
  );
  return wantedItem !== null && wantedItem.value !== "";
}

// NOTE: the wanted_item radios are visually hidden (see _gift-products.scss),
// so native setCustomValidity/reportValidity can't reliably anchor a bubble to
// them. Surface the error the same way server-side wanted_item errors render:
// an .errorlist inside #goaas.
function clearDonationProductError() {
  const donationProductChoices = document.getElementById("goaas");
  donationProductChoices?.querySelector(".wanted-item-error")?.remove();
}

function showDonationProductError() {
  const donationProductChoices = document.getElementById("goaas");
  if (donationProductChoices === null) {
    return;
  }
  clearDonationProductError();
  const errorList = document.createElement("ul");
  errorList.className = "errorlist wanted-item-error";
  const errorItem = document.createElement("li");
  errorItem.textContent = window.gettext("Please select an item");
  errorList.appendChild(errorItem);
  const productRow = donationProductChoices.querySelector(".gift-products-row");
  donationProductChoices.insertBefore(errorList, productRow);
  donationProductChoices.scrollIntoView({ behavior: "smooth", block: "center" });
}
// =======================
// Donation Amount Section
// =======================}
const totalFormsField = document.getElementById("id_donation_set-TOTAL_FORMS");
const maxForms = document.getElementById("id_donation_set-MAX_NUM_FORMS").value;
const donationFormSets = document.getElementsByClassName("gift");

const formsetTotals = {}; // { uuid: number }
const parser = new DOMParser();
const totalSummary = document.getElementById("totalSummary");
const totalSummaryAmount = document.querySelector("#totalSummary .amount");
totalSummary.className = (radioMonthly?.checked || radioOneTime == null) ? 'monthly' : 'onetime';
if (totalSummary.className === 'monthly') {
  totalSummary.querySelector('span.description').innerText = window.gettext("Total monthly donation amount");
}

const resetFormSetNumbering = () => {
  // field names need correct fieldset numbers for django to process
  const formSets = Array.from(document.getElementsByClassName("gift"));
  formSets.forEach((formset, i) => {
    formset.querySelectorAll('[for],[id],[name]').forEach(node => {
      ['for', 'id', 'name'].forEach(attr => {
        if (node.getAttribute(attr)) node.setAttribute(attr, node.getAttribute(attr).replace(RegExp(`donation_set-(\\d){1}-`, 'g'), `donation_set-${i}-`))
      });
    });
  });
  totalFormsField.value = formSets.length;
}

const updateTotalSummary = (uuid, amount) => {
  if (uuid && amount) formsetTotals[uuid] = amount;
  if (radioMonthly?.checked || radioOneTime?.checked) {
    // only change summary classname if recurrence radio options are present
    const giftRecurrence = radioMonthly?.checked ? 'monthly' : 'onetime';
    totalSummary.className = giftRecurrence === 'monthly' ? 'monthly' : 'onetime';
    if (totalSummary.className === 'monthly') {
      totalSummary.querySelector('span.description').innerText = window.gettext("Total monthly donation amount");
    } else {
      totalSummary.querySelector('span.description').innerText = window.gettext("Total donation amount");
    }
  }
  totalSummaryAmount.innerText = (Object.values(formsetTotals).reduce((partialSum, a) => partialSum + Number(a), 0)).toFixed(2);
}

const testIfDeletionAllowed = () => {
  if (Object.keys(formsetTotals).length < 2) {
    document.getElementsByClassName("gift")[0].setAttribute('data-disable-delete', 1);
  } else {
    document.querySelectorAll("[data-disable-delete]").forEach(node => node.removeAttribute('data-disable-delete'));
  }
}

const deleteFormSet = (uuid) => {
  const nodeToDelete = document.querySelector(`[data-uuid="${uuid}"]`);
  if (nodeToDelete && Object.keys(formsetTotals).length > 1) {
    nodeToDelete.remove();
    delete formsetTotals[uuid];
    updateTotalSummary('');
    resetFormSetNumbering();
    testIfDeletionAllowed();
  }
}

const initFormSet = (formSet, uuid) => {
  formSet.setAttribute('data-uuid', uuid);
  const customAmtInput = formSet.querySelector("input[name$=-amount_custom]");
  const amtRadios = formSet.querySelectorAll("input[name$=amount]");

  const onGiftConditionsChange = () => {
    const checkedAmtRadio = formSet.querySelector("input[name$=amount]:checked");
    if (checkedAmtRadio || customAmtInput.value) {
      const amountChoice = checkedAmtRadio ? checkedAmtRadio.value : customAmtInput.value;
      updateTotalSummary(uuid, amountChoice !== 'custom' ? amountChoice : customAmtInput.value);
    }
  };
  onGiftConditionsChange();

  // clear out custom amount input box if any other radio is selected
  amtRadios.forEach((input) => {
    input.addEventListener("change", (e) => {
      onGiftConditionsChange();
      if (e.target.value != "custom" && e.target.checked) {
		customAmtInput.blur();
        customAmtInput.value = "";
		customAmtInput.setCustomValidity("");
		delete customAmtInput.parentElement.dataset.checked;
      }
    });
  });

  customAmtInput.parentElement.addEventListener("click", () => customAmtInput.focus());
  const lastAmtRadio = amtRadios[amtRadios.length - 1];
  lastAmtRadio.addEventListener("click", () => customAmtInput.focus());
  lastAmtLabel = document.querySelector(`label[for=${lastAmtRadio.id}]`);
  if (lastAmtLabel) {
	lastAmtLabel.addEventListener("click", () => customAmtInput.focus());
  }
  // add class to 'Other' parent elem for label positioning
  customAmtInput.addEventListener('focus', e => {
	// uncheck other
	for (const input of amtRadios) {
	  input.checked = input.value == "custom";
	}
	customAmtInput.parentElement.dataset.hasFocus = true;
  });

  customAmtInput.addEventListener('blur', evt => {
	delete evt.target.dataset.hasFocus;
	evt.target.setCustomValidity("");
	onGiftConditionsChange();
	if (evt.target.value == "") {
	  evt.target.setCustomValidity(gettext("Please enter your donation amount or select a different choice"));
	  setTimeout(() => evt.target.reportValidity(), 600);
	}
  });

  // select 'Other' radio button when typing in custom amount field
  customAmtInput.addEventListener('keyup', () => {
    for (let i=0; i < amtRadios.length; i++) {
      if (i === (amtRadios.length - 1)) {
        amtRadios[i].checked = true;
		customAmtInput.parentElement.dataset.checked = true;
      } else {
        amtRadios[i].checked = false;
		delete customAmtInput.dataset.checked;
      }
    }
  });

  // disable the scrollwheel when focus on custom amount field
  customAmtInput.addEventListener('wheel', (event) => {
	  event.target.blur();
  });
  // add or update delete button
  let deleteButton = formSet.querySelector('.delete');
  if (!deleteButton) {
    const deleteNode = parser.parseFromString(`<span class="delete"><button class="btn"><svg class="icon" width="14" height="14" alt="Delete"><use href="#x"></svg></button></span>`, 'text/html').body.firstElementChild;
    formSet.querySelector(".giftDetails").appendChild(deleteNode);
    deleteButton = deleteNode.firstElementChild;
  }
  deleteButton.addEventListener('click', (e) => {
    e.preventDefault();
    deleteFormSet(uuid);
  });
  testIfDeletionAllowed();
}
Array.from(donationFormSets).forEach((formSet, i) => {
  const uuid = window.crypto.randomUUID();
  formsetTotals[uuid] = 0;
  initFormSet(formSet, uuid);
});

radioMonthly?.addEventListener("click", () => updateTotalSummary(''));
radioOneTime?.addEventListener("click", () => updateTotalSummary(''));

// if neither radio buttons exist, add similarly styled (as radio label buttons) element above gift
if (recurrenceInputs.length === 1) {
  const recurrenceLabel = window.gettext(recurrenceInputs[0].value);
  const recurrenceContext = parser.parseFromString('<div id="div_recurrence" class="form-group  gift-frequency basic-labels"><span class="default selected">'+ recurrenceLabel + '</span></div>', 'text/html').body.firstElementChild;
  donationFormSets[0].insertAdjacentElement('beforebegin', recurrenceContext);
}

const addDonationBtn = document.getElementById("add-donation-item");
if (addDonationBtn !== null) {
  addDonationBtn.addEventListener("click", clickEvt => {
    clickEvt.preventDefault();
    const formNum = document.getElementsByClassName("gift").length;
    if (formNum >= maxForms) {
      alert(`Adding more than ${maxForms} donations is not allowed.`)
      return;
    }
    const newFormSet = donationFormSets[0].cloneNode(true);
    newFormSet.id = "amount-section-" + formNum;
    newFormSet.innerHTML = newFormSet.innerHTML.replace(RegExp(`donation_set-(\\d){1}-`, 'g'), `donation_set-${formNum}-`);
    clickEvt.target.insertAdjacentElement("beforebegin", newFormSet);
    const uuid = window.crypto.randomUUID();
    formsetTotals[uuid] = 0;
    initFormSet(newFormSet, uuid);
    totalFormsField.value = formNum + 1;
    testIfDeletionAllowed();
  });
}

// ==============================
// Donation Payment Types Section
// ==============================
document.addEventListener('DOMContentLoaded', updatePayOptionTabs, {once: true});
document.addEventListener('DOMContentLoaded', checkAndToggleUseOnDay, {once: true});
document.addEventListener('DOMContentLoaded', () => {
  const contentIdRe = /^\#(?<id>[a-z-_]+)$/;
  
  // clears contents of pay method panes
  let payMethods = document.querySelectorAll('#paymethod-nav a');
  if (payMethods.length) {
    for (let payMethod of payMethods) {
	  const contentID = payMethod.getAttribute('href').match(contentIdRe).groups.id;
      payMethod.addEventListener("click", (event) => { 
        event.preventDefault();
        const closestLi = event.target.closest('li');
        const closestUl = event.target.closest('ul');
        const closestA = event.target.closest('a');

        // depends on if admin 'Display recurrence options' checkbox is checked
        let inputRecurrence; 
        if (document.querySelector('input[name="recurrence"]:checked') === null ) {
          inputRecurrence = document.querySelector('input[name="recurrence"]').value;
        } else {
          inputRecurrence = document.querySelector('input[name="recurrence"]:checked').value;
        } 

        // if clicking on currently active tab, do nothing
        // or if "monthly" frequency and tab clicked is paypal
        if (
          closestLi.classList.contains('active') || (
            closestLi.classList.contains('no-monthly') && inputRecurrence === "Monthly" 
          )
        ) {
           // do nothing
        } else {
          // do all actions:
          // [1] update hidden value field
          const hiddenPaymentMethod = document.querySelector('input[name="payment_method"]');
          hiddenPaymentMethod.value = closestA.dataset['paymentmethod'];
          
          
          // [2] update submit button text
          const submitButton = document.querySelector('button[type=submit]');
          submitButton.innerText = closestLi.dataset['buttonText'];


          // [3] update tab classes to designate active
          for (let li of closestUl.children) {
            li.classList.remove('active');
          }
          closestLi.classList.add('active');

          // [4] 
          clearTabContents(contentID);
        }
      });
	  payMethod.addEventListener("click", event => disableMonthlyRadio(event.target));
    }
	const activeTab = document.querySelector('#paymethod-nav .active a');
	if (activeTab) {
	  clearTabContents(activeTab.getAttribute('href').match(contentIdRe).groups.id);
	  disableMonthlyRadio(activeTab);
	}
  } else {
	// disable monthly if payment pane has no-monthly class
	const activePane = document.querySelector("#paymethod-panes .method.active");
	if (activePane.classList.contains("no-monthly") && radioMonthly !== null) {
	  radioOneTime.checked = true;
	  radioMonthly.disabled = true;
	  radioMonthly.parentElement.classList.add('disabled');
	}
  }

  // if error on page, scroll to top on load
  if (document.querySelector('.messages')) {
	  window.scrollTo({
		  top: document.getElementById('donation').offsetTop,
		  left: window.scrollX,
		  behavior: 'smooth'
	  });
  }
 
});


// ==============================
// Form Submission
// ==============================
document.addEventListener("DOMContentLoaded", () => {
  const donateForm = document.getElementById("form-donate");
  const paymentMethod = document.querySelector("input[name='payment_method']");
  const minAmtOneTimeDialog = document.querySelector("[data-modal='min-amt-once-modal']");
  const minAmtMonthlyDialog = document.querySelector("[data-modal='min-amt-monthly-modal']");
  const rpInterruptDialog = document.getElementById("dialog-interrupt");
  const minAmtResourceDialogs = document.querySelectorAll(".min-amt-resource-dialog");
  const recurringMethodsScript = document.getElementById("monthly-payment-options-data");
  const monthlyPayMethods = recurringMethodsScript ? JSON.parse(recurringMethodsScript.textContent) : ["cardconnect", "eft", "credit_card"];
  let interruptHasFired = false;

  document.querySelectorAll("input[name='wanted_item']").forEach((input) => {
    input.addEventListener("change", clearDonationProductError);
  });

  donateForm.addEventListener("submit", (event) => {
    event.preventDefault();
    document.querySelector(".btn-group").classList.add("wait");
    const wantedItem = document.querySelector("input[name='wanted_item']:checked");

    if (!hasRequiredDonationProductSelection()) {
      document.querySelector(".btn-group").classList.remove("wait");
      showDonationProductError();
      return;
    }
    clearDonationProductError();

    // depends on if admin 'Display recurrence options' checkbox is checked
    let inputRecurrence; 
    if (document.querySelector('input[name="recurrence"]:checked') === null ) {
      inputRecurrence = document.querySelector('input[name="recurrence"]').value;
    } else {
      inputRecurrence = document.querySelector('input[name="recurrence"]:checked').value;
    } 

    // amount of donation
	const donationTotal = Array.from(document.querySelectorAll("input[name$=amount]:checked,input[name$=amount_custom]"))
		  .map(el => Number(el.value))
		  .filter(v => !isNaN(v))
		  .reduce((partial, v) => partial + v, 0);

    // if donation is less than one-time minimum throw modal
    if (minAmtOneTimeDialog && inputRecurrence === "One Time") {
      const oneTimeRequiredAmt = parseInt(minAmtOneTimeDialog.getAttribute("data-amount"));
      if (donationTotal < oneTimeRequiredAmt) {
        minAmtOneTimeDialog.showModal();
        interruptHasFired = true;
        return;
      }
    }
    
    // if donation is less than monthly minimum throw modal
    if (minAmtMonthlyDialog && inputRecurrence === "Monthly") {
      const monthlyRequiredAmt = parseInt(minAmtMonthlyDialog.getAttribute("data-amount"));
      if (donationTotal < monthlyRequiredAmt) {
        minAmtMonthlyDialog.showModal();
        interruptHasFired = true;
        return;
      }
    }

    // if donation is less than amount for any given product throw modal
    for (const element of minAmtResourceDialogs) {
      const value = element.getAttribute("data-value");
      const minAmt = element.getAttribute("data-amount");

      if (wantedItem !== null && value === wantedItem.value && donationTotal < parseInt(minAmt)) {
        element.showModal();
        interruptHasFired = true;
        return;
      } 
    }

    // if interrupter is enabled throw the modal
    if (!interruptHasFired) {
      if (
        rpInterruptDialog && 
          inputRecurrence === "One Time" &&
		  monthlyPayMethods.includes(paymentMethod.value)
      ) {
        rpInterruptDialog.showModal();
        interruptHasFired = true;
        return;
      }
    }
   

    // hacky way of handling information submitted for station selection
    // adds field name value
    if (autocompleteDiv !== null) {
      const autocompleteInput = autocompleteDiv.querySelector('input');
      autocompleteInput.setAttribute("name", "where_do_you_listen_1");
    }

    // if all tests pass up to this point, submit the form
    maybeSubmitForm(event.target);
    
  });


  // on rp-interrupter: proceed with one time donation
  const modalInterruptProceedButton = document.querySelector('[data-modal-proceed-donate]');
  if (modalInterruptProceedButton) {
    modalInterruptProceedButton.addEventListener("click", () => {
      const donateForm = document.querySelector("#form-donate");
	  maybeSubmitForm(donateForm);
	  return;
    });
  } else {
    console.debug("no proceed button found");
  }


  // on rp-interrupter: convert donation to monthly 
  const modalInterruptPartnerButton = document.querySelector('[data-modal-proceed-partner]');
  if (modalInterruptPartnerButton) {
    modalInterruptPartnerButton.addEventListener("click", () => {
      const donateForm = document.querySelector("#form-donate");

      // set monthly information
      document.querySelector("input[name='recurrence'][value='Monthly']").checked = true;
      document.querySelector("select[name='use_on_day']").value = "5";
      // document.querySelector("input[name='amount']:checked").value = "30.00";
	  maybeSubmitForm(donateForm);
      return;
    });
  } else {
    console.debug("no monthly button found");
  }


  // if recommended donation modal is triggered
  // this form submission happens on proceed button click
  const modalProceedButton = document.querySelector('[data-modal-proceed]');
  if (modalProceedButton) {
    modalProceedButton.addEventListener("click", () => {
      const donateForm = document.querySelector("#form-donate");

      if (autocompleteDiv !== null) {
        const autocompleteInput = autocompleteDiv.querySelector('input');
        autocompleteInput.setAttribute("name", "where_do_you_listen_1");
      }

      if (!hasRequiredDonationProductSelection()) {
        showDonationProductError();
        return;
      }
      clearDonationProductError();
      document.querySelector(".btn-group").classList.add("wait");
	  maybeSubmitForm(donateForm);
      return;

    });
  }




}); 



// check to make sure the radios even exist
// if they exist change payment tabs' selectability 
// based on radio selection
let frequencyRadios = document.querySelectorAll('input[name="recurrence"]');
if (frequencyRadios) {
  frequencyRadios.forEach((el) => {
    el.addEventListener("change", updatePayOptionTabs);
  });
}


